
import api from '../../../api/client';
import { TABLE_PREFERENCE } from '../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../api/handlers';

export const getColumnPreference = async (tableKey) => {
    try {
        const response = await api.get(TABLE_PREFERENCE.SHOW(tableKey));
        return handleApiResponse(response);
    } catch (error) {
        return handleApiError(error);
    }
};

export const saveColumnPreference = async (tableKey, hiddenColumns) => {
    try {
        const response = await api.put(TABLE_PREFERENCE.UPDATE(tableKey), {
            hidden_columns: hiddenColumns,
        });
        return handleApiResponse(response);
    } catch (error) {
        return handleApiError(error);
    }
}